import type { StoreConfig } from "@jti/store/slices/magentoApiSlice";
import type { GetProfileQueryData } from "@jti/store/slices/profileApiSlice";
import type { Translate } from "@jti/ui";

import type { FormFieldConfig, FormFieldFactory } from "@checkout-v2/formFields";

export type FirstNameFieldConfig = FormFieldConfig<"firstName"> & {
  savedDefaultValue: string;
};

export type FirstNameFieldConfigArgs = {
  storeConfig: StoreConfig;
  profile: GetProfileQueryData;
  __: Translate;
};

export type FirstNameGetDefaultValueArgs = {
  profile: GetProfileQueryData;
  storeConfig: StoreConfig;
};

export const firstNameFieldFactory: FormFieldFactory<
  "firstName",
  string,
  [FirstNameFieldConfigArgs],
  [FirstNameGetDefaultValueArgs],
  FirstNameFieldConfig
> = {
  getDerivedConfig: ({ __, storeConfig, profile }) => {
    return {
      name: "firstName",
      label: __("contact_info.first_name"),
      placeholder: __("contact_info.first_name"),
      registerOptions: { required: true, disabled: false },
      isHidden: !!storeConfig?.allowEmptyFirstname,
      savedDefaultValue: firstNameFieldFactory.getDefaultValue({ profile, storeConfig }),
    };
  },
  getDefaultValue: ({ profile, storeConfig }) => {
    return !storeConfig?.allowEmptyFirstname ? (profile.personalInfo.firstname ?? "") : "";
  },
};
